const cadastrar_a_solicitacao = [
  {
    path: "/cadastrar-a-solicitacao",
    redirect: "",
    meta: {
      breadCrumb:
        "Gestão - Cadastrar as Solicitações de Serviços de uma Unidade para outra",
    },
    children: [
      {
        path: "/cadastrar-a-solicitacao",
        name: "cadastrar_a_solicitacao",
        component: () =>
          import("@/views/CadastrarASolicitacao/CadastrarASolicitacaoHome.vue"),
      },
      {
        path: "/cadastrar-a-solicitacao/novo",
        name: "cadastrar_a_solicitacao_novo",
        component: () =>
          import("@/views/CadastrarASolicitacao/CadastrarASolicitacaoCad.vue"),
      },
      {
        path: "/cadastrar-a-solicitacao/:id/editar",
        name: "cadastrar_a_solicitacao_editar",
        component: () =>
          import("@/views/CadastrarASolicitacao/CadastrarASolicitacaoEdit.vue"),
      },
      {
        path: "/cadastrar-a-solicitacao/:id/visualizar",
        name: "cadastrar_a_solicitacao_visualizar",
        component: () =>
          import("@/views/CadastrarASolicitacao/CadastrarASolicitacaoEdit.vue"),
      },
    ],
  },
];

export { cadastrar_a_solicitacao };
